import { gql } from '@apollo/client';

export const ReportReviewQuery = gql`
  query($jobId: Int) {
    ReportReview(jobId: $jobId) {
      allNotesCount
      closedNotesCount
      currentUserRoles {
        name
      }
      reportReviewNotes {
        editable
        closedAt
        createdAt
        id
        type
        typeId
        typeVersionId
        typeQuestionId
        note
        noteHtml
        isExternal
        user {
          id
          lastName
          firstName
        }
        reportReviewComments {
          editable
          id
          reportReviewNoteId
          comment
          commentHtml
          createdAt
          user {
            id
            lastName
            firstName
            roles {
              name
            }
          }
        }
      }
      reportNotes {
        closedAt
        createdAt
        id
        type
        typeId
        typeVersionId
        typeQuestionId
        note
        noteHtml
        user {
          id
          lastName
          firstName
        }
        reportReviewComments {
          id
          reportReviewNoteId
          comment
          commentHtml
          createdAt
          user {
            id
            lastName
            firstName
            roles {
              name
            }
          }
        }
      }
    }
  }
`;
